import { store } from '@/store';

class Permissions {
  static getSelectedGroupRoles() {
    return store.state.authentication.user.groups
      .find((group) => group.name === store.state.selectedGroup).roles;
  }

  static hasAny(...rolesToCheck) {
    const groupRoles = this.getSelectedGroupRoles();
    return rolesToCheck.reduce((acc, cur) => {
      if (groupRoles.includes(cur)) return true;
      return acc;
    }, false);
  }

  static hasAll(...rolesToCheck) {
    const groupRoles = this.getSelectedGroupRoles();
    return rolesToCheck.reduce((acc, cur) => {
      if (!groupRoles.includes(cur)) return false;
      return acc;
    }, true);
  }
}

export default Permissions;
